module.exports = __webpack_public_path__ + "ae5657345f1882e69bcaed29896f0176.svg";